import AccessControl from '@modules/auth/AccessControl'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { Trans } from 'react-i18next'
import { history } from '@services/History'

export class DerivationsTable extends Component {
  static defaultProps = {
    derivations: [],
  }

  static propTypes = {
    derivations: PropTypes.array,
  }

  render() {
    const { derivations } = this.props
    return (
      <table className="md-table">
        <thead>
          <tr>
            <th className="col-largest">
              <Trans>Mensaje de la derivación</Trans>
            </th>
            <th>
              <Trans>Url</Trans>
            </th>
            <th>
              <Trans>Teléfono</Trans>
            </th>
            <AccessControl>
              <th>
                <Trans>Compañía</Trans>
              </th>
            </AccessControl>
          </tr>
        </thead>
        <tbody>
          {derivations.map((derivation) => (
            <tr key={derivation.id} onClick={() => history.extend(`/${derivation.id}`)}>
              <td className="col-show-content">{derivation.message}</td>
              <td className="col-center">
                <a href={derivation.url_value} target={'_blank'} rel="noopener noreferrer">
                  {derivation.url_value || '-'}
                </a>
              </td>
              <td className="col-center">{derivation.phone_value || '-'}</td>

              <AccessControl>
                <td className="col-center">{derivation.company && derivation.company.name}</td>
              </AccessControl>
            </tr>
          ))}
        </tbody>
      </table>
    )
  }
}
